var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_6982)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_6982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1655,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_6982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.1412 0.283304C-5.68435 -0.262184 -5.47085 -1.21268 -4.74658 -1.4735C1.32729 -3.6608 9.14934 -7.67875 15.3197 -6.29288C21.49 -4.90701 26.8423 2.06995 31.3974 6.64454C31.9405 7.19002 31.727 8.14052 31.0028 8.40134C24.9289 10.5886 17.1068 14.6066 10.9365 13.2207C4.7662 11.8348 -0.586176 4.85789 -5.1412 0.283304Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5128 43.4918C10.9673 44.0349 10.0168 43.8214 9.75598 43.0972C7.56865 37.0233 3.55066 29.2013 4.9365 23.0309C6.32234 16.8606 13.2993 11.5082 17.8738 6.95319C18.4193 6.41004 19.3698 6.62354 19.6306 7.3478C21.818 13.4217 25.8359 21.2437 24.4501 27.414C23.0643 33.5844 16.0873 38.9368 11.5128 43.4918Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83947 -1.13242C2.02719 -1.88092 0.750137 -1.8354 0.108762 -0.936128C-0.719755 0.225538 -1.39092 1.4953 -1.88472 2.84036C-2.60883 4.81278 -2.93735 6.90851 -2.85153 9.00789C-2.76572 11.1073 -2.26724 13.1692 -1.38456 15.0759C-0.782625 16.3762 -0.0100604 17.587 0.910509 18.6772C1.62314 19.5211 2.89964 19.4622 3.64813 18.6499L11.7797 9.82527C12.5281 9.01298 12.4764 7.74771 11.6641 6.99921L2.83947 -1.13242Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8641 26.3187C18.7431 26.8575 19.0816 27.3969 19.6287 27.4727C21.6377 27.7509 23.6904 27.516 25.5929 26.7823C27.8073 25.9283 29.7187 24.4368 31.0854 22.4964C32.4521 20.5561 33.2127 18.254 33.2711 15.8814C33.3294 13.5087 32.6829 11.172 31.4133 9.16679C30.1436 7.16156 28.3079 5.57785 26.1382 4.61592C23.9685 3.654 21.5623 3.35707 19.2239 3.76268C16.8854 4.1683 14.7198 5.25823 13.0008 6.89466C11.5239 8.3006 10.4337 10.0557 9.82608 11.9907C9.66062 12.5176 10.0034 13.0543 10.5422 13.1754L20.2991 15.367C20.8379 15.488 21.1767 16.023 21.0556 16.5618L18.8641 26.3187Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2757 11.7009C21.0449 10.2335 20.4824 8.39353 18.9077 7.87853C15.3742 6.72297 11.5431 6.68241 7.94773 7.80502C3.39085 9.22783 -0.414167 12.4025 -2.63027 16.6308C-4.84637 20.859 -5.29202 25.7943 -3.86918 30.3511C-2.74655 33.9464 -0.533284 37.0737 2.42757 39.3218C3.74711 40.3237 5.58024 39.7392 6.34937 38.2718L13.3126 24.9864L20.2757 11.7009Z",
    fill: "#267CBC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_6982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.165527)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg4);
export default __webpack_public_path__ + "static/media/profileImg4.c0fc3488685a7ab05f205ebf104e4483.svg";
export { ForwardRef as ReactComponent };